import moment from "moment"
import React, { useEffect, useState } from "react"
import { Dimensions, StyleSheet, Text, TouchableOpacity, View } from "react-native"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"
import { Spacer } from "@Components/Space"

moment.locale("fr")

const { width } = Dimensions.get("screen")

export const MultipleDaySelector = (props) => {
    const { selected, handleChange, allowWeekendDay } = props
    const today = new Date()
    const week = [
        { label: "L", value: 1 },
        { label: "Mar", value: 2 },
        { label: "Mer", value: 3 },
        { label: "J", value: 4 },
        { label: "V", value: 5 },
        { label: "S", value: 6 },
        { label: "D", value: 7 }
    ]
    useEffect(() => {
        setSelectedDay([...selected])
        handleChange?.(selected)
    }, [selected])

    const [selectedDay, setSelectedDay] = useState([])

    const handleSelect = (day) => {
        let newSelected = selectedDay
        if (selectedDay?.includes(day)) {
            setSelectedDay((prev) => [...prev.filter((itm) => itm != day)])
            newSelected = [...selectedDay.filter((itm) => itm != day)]
        } else {
            setSelectedDay((prev) => [...prev, day])
            newSelected = [...selectedDay, day]
        }

        handleChange?.(newSelected)
    }

    const DayComponent = ({ date, hidden, allowWeekendDay }) => {
        const selected = hidden ? false : selectedDay.includes(date.value)
        const selectedColor = selected ? baseColors.green.primary : hidden ? baseColors.white : baseColors.green.light
        const color = selected ? baseColors.white : hidden ? baseColors.white : baseColors.green.primary

        return (
            <TouchableOpacity
                disabled={props.disabled}
                style={{
                    ...styles.container,
                    backgroundColor: selectedColor
                }}
                onPress={() => {
                    !hidden && handleSelect(date.value)
                }}
            >
                <View>
                    <OpenSansText textAlign={"center"} fontSize={16} color={color}>
                        {!hidden && date.label.substr(0, 1)}
                    </OpenSansText>
                </View>
            </TouchableOpacity>
        )
    }
    return (
        <View style={{ width: width - 40 }}>
            <View style={styles.col}>
                {week
                    .filter((d) => d.label !== "S" && d.label !== "D")
                    .map((day, i) => (
                        <DayComponent date={day} key={i} />
                    ))}
            </View>

            <Spacer height={20} />

            <View style={{ ...styles.col, flexDirection: "row-reverse" }}>
                {[...week.slice(0, 3).reverse(), ...week.slice(5, 7).reverse()].map((day, i) => (
                    <DayComponent
                        allowWeekendDay={allowWeekendDay}
                        hidden={day.label == "S" || day.label == "D" ? false : true}
                        key={i}
                        date={day}
                    />
                ))}
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: "column",
        padding: 10,
        alignContent: "center",
        alignItems: "center",
        width: 47,
        height: 47,
        borderRadius: 10,
        justifyContent: "center",
        alignItems: "center",
        alignContent: "center"
    },
    col: { flexDirection: "row", justifyContent: "space-between" },
    DayComponentContainer: {
        flexDirection: "row-reverse",
        flex: 2,
        flexGrow: 2,
        justifyContent: "space-between"
    }
})
